import {css} from 'emotion'
import { Label, Colors, Link, ButtonWhite, CardTitle, SliderTitle, MenuH2 } from './../'
import { Easings } from '../core'
import URL from './../../static/montre-dark.jpg'

export const PushQuizzStyle = () => css({
  background: '#292a2b',
  //  background: `url(${URL}) no-repeat center`,
  //  backgroundSize: 'cover',
  'h3': {
    ...Label,
    color: 'white',
    textTransform: 'uppercase',
    fontWeight: 'bold',
  },
  'p': {
    color: 'white',
  },
  '.btn': {
    ...ButtonWhite,
    display: 'block',
    color: Colors.darkGrey,
    transition: 'all 400ms ease',
    margin: '2rem 0px',

    '&:hover': {
      color: 'white',
      background: 'black',
    }
  },
  '.link': {
    ...Link,
    color: Colors.red,
    transition: 'color 400ms ease',
    '&:hover': {
      color: 'white',
    }
  },
  '.push-quizz-inner': {
    position: 'relative',
    zIndex: 2,
    padding: '4rem',
    textAlign: 'center',

    '@media (min-width: 1224px)': {
      padding: '6rem 4rem',
    }
  }
})

export const PushHighScoreStyle = css({
  '.link': {
    ...Link,
    color: 'black',
    margin: '3rem 0',
    display: 'block',
    transition: 'color 200ms ease',
    '&:hover': {
      color: Colors.red,
    }
  },
  'h3': {
    ...CardTitle,
  },
  '.ranking-table': {
    '.ranking-line': {
      padding: '0.4rem 0px',
      alignItems: 'center',
      fontWeight: 'bold',
      fontSize: '0.9375rem',
      '&.current': {
        position: 'relative',
        '&:after': {
          content: "''",
          width: '100%',
          height: 'calc(100% + 2px)',
          border: '2px solid #000',
          position: 'absolute',
          top: 0,
          left: 0,
          transform: 'translateX(-2px) translateY(-2px)',
        },
        '&--menu:after': {
          borderColor: Colors.red,
        }
      },
      '.number': {
        maxWidth: '40px',
        flexBasis: '40px',
        paddingLeft: '0.5rem',
      },
      '.score': {
        maxWidth: '40px',
        flexBasis: '40px',
        color: Colors.red,
      },
      '.localisation': {
        maxWidth: 'calc(50% - 40px )',
        flexBasis: 'calc(50% - 40px )',
        color: Colors.mediumGrey,
        textTransform: 'uppercase',
        paddingLeft: '0.5rem',
      },
      '.name': {
        maxWidth: 'calc(50% - 40px )',
        flexBasis: 'calc(50% - 40px )',
        paddingLeft: '0.5rem',
      },
    },
    '.first': {
      border: '2px solid black',
      '&.current': {
        border: `2px solid ${Colors.red}`,
      },
      '.number': {
        color: Colors.red,
      }
    }
  }
})

export const CurrentRankingStyle = (isMenu) => css({
  textAlign: 'center',
  '.current': {
    color: Colors.red,
    fontWeight: 'bold',
    ...SliderTitle,
    'sup': {
        fontSize: '2rem',
        textTransform: 'none',
     }
  },
  '.current-ranking-label': {
    textTransform: 'uppercase',
    fontWeight: 'bold',
  },
  '.link': {
    ...Link,
    color: 'black',
    margin: '2rem 0',
    display: 'inline-block',
  },
}, isMenu && {
  textAlign: 'left',
  '.current': {
     ...MenuH2,
     fontFamily: 'Interstate-bold',
  },
  '.all': {
    display: 'inline-block',
    color: Colors.mediumGrey,
    fontFamily: 'Interstate-bold',
    transform: 'translateY(0.5rem)',
  }
})

export const RankingIQStyle = (isMenu, x) => css({
  position: 'relative',
  textAlign: 'center',
  '.label': {
    textTransform: 'uppercase',
    fontWeight: 'bold',
  },
  '.score': {
    ...SliderTitle,
    color: Colors.red,
    fontFamily: 'Interstate-bold',
  },
  '.ranking-iq-progress': {
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: 160,
    height: 160,
    transform: 'translate(-50%, -50%)',
    zIndex: 0,
    '@media (min-width: 1024px)': {
      width: 270,
      height: 270,
    },
    'svg': {
      width: '100%',
      height: '100%',
      fill: 'none',
      transform: 'rotate(-90deg)',
    },
    '.progress': {
      stroke: Colors.extraLightGrey, 
      strokeWidth: 2,
    },
    '.progress-bar': {
      stroke: Colors.red,
      strokeWidth: 2,
      strokeDasharray: 251.327412287,
      strokeDashoffset: 251,
    },
    
  },
}, isMenu && {
  '.score': {
    ...MenuH2,
    fontWeight: 'bold',
    fontFamily: 'Interstate-bold',
  },
  '.ranking-iq-progress': {
    width: 160,
    height: 160,
  },
}, x && {
  '.progress-bar': {
    animation: `progress 1s ${Easings.customEase} forwards`,
  },
  '@keyframes progress' : {
    '0%': {
      strokeDashoffset: 251,
    },
    '100%': {
      strokeDashoffset: x,
    }
  }
})

export const BestRankingStyle = css({
  textAlign: 'center',
  '.label': {
    textTransform: 'uppercase',
    fontWeight: 'bold',
  },
  '.number': {
    color: Colors.red,
    ...SliderTitle,
    fontWeight: 'bold',
    'sup': {
      fontSize: '2rem',
      textTransform: 'none',
    }
  }
})

export const QuizzRankingStyle = (x) => css({
  position: 'relative',
  textAlign: 'center',
  boxShadow: `0 0 20px 0 ${Colors.shadow}`,
  paddingBottom: '1rem',
  '&:after': {
    position: 'absolute',
    bottom: 0,
    left: 0,
    content: "''",
    width: `calc(${x}/100 * 100%)`,
    height: 4,
    background: Colors.red,
    transform: 'scaleX(0)',
    transformOrigin: 'center left',
    animation: `progress2 200ms ${Easings.customEase} forwards 400ms`
  },
  '.label': {
    textTransform: 'uppercase',
    fontWeight: 'bold',
   
  },
  '.link': {
    ...Link,
    color: 'black',
    margin: '1rem 0',
    display: 'inline-block',
    '@media (min-width: 1024px)': {
      margin: '2rem 0',
    }
  },
  '.quizz-ranking-number':{
    margin: '2rem 0',
  },
  '.number': {
    color: Colors.red,
    ...MenuH2,
    fontFamily: 'Interstate-bold',
  },
  '.all': {
    position: 'relative',
    display: 'inline-block',
    color: Colors.mediumGrey,
    ...Label,
    fontWeight: 'bold',
    transform: 'translateY(10px)',
  }
})


// WEBPACK FOOTER //
// ./src/styles/components/challenge.js